/**
 * OrbDocTutorialsAdvancedAiGenerationARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsAdvancedAiGenerationARDocScreen
 */

import { useOrbDocTutorialsAdvancedAiGenerationARDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsAdvancedAiGenerationARDocScreenLogic';
import type { OrbDocTutorialsAdvancedAiGenerationARDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsAdvancedAiGenerationARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsAdvancedAiGenerationARDocView as OrbDocTutorialsAdvancedAiGenerationARDocViewEntity } from '@app/shared';
import { OrbDocTutorialsAdvancedAiGenerationARDocBodyView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationARDocBodyView';
import { OrbDocTutorialsAdvancedAiGenerationARDocFooterView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationARDocFooterView';
import { OrbDocTutorialsAdvancedAiGenerationARDocHeaderView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsAdvancedAiGenerationARDocScreenViewProps {
  config?: Partial<OrbDocTutorialsAdvancedAiGenerationARDocScreenConfig>;
}

export function OrbDocTutorialsAdvancedAiGenerationARDocScreenView({ config: propsConfig }: OrbDocTutorialsAdvancedAiGenerationARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsAdvancedAiGenerationARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsAdvancedAiGenerationARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsAdvancedAiGenerationAR" trait="OrbDocTutorialsAdvancedAiGenerationARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsAdvancedAiGenerationARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsAdvancedAiGenerationARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedAiGenerationARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsAdvancedAiGenerationARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsAdvancedAiGenerationARDocScreenView;
